/* global axios */
import ApiClient from './ApiClient';

class MinimaxAPI extends ApiClient {
  constructor() {
    super('minimax', { accountScoped: true });
  }

  getVoices() {
    return axios.get(`${this.url}/voices`);
  }

  cloneVoice(file, agentBotId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('agent_bot_id', agentBotId);
    return axios.post(`${this.url}/clone_voice`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  deleteVoice(voiceId, agentBotId) {
    return axios.delete(`${this.url}/delete_voice`, {
      data: { voice_id: voiceId, agent_bot_id: agentBotId },
    });
  }

  previewVoice(voiceId, agentBotId, text) {
    return axios.post(`${this.url}/preview_voice`, {
      voice_id: voiceId,
      agent_bot_id: agentBotId,
      text,
    });
  }

  getVoiceSample(agentBotId) {
    return axios.get(`${this.url}/voice_sample`, {
      params: { agent_bot_id: agentBotId },
    });
  }
}

export default new MinimaxAPI();
